import React from 'react';
import { Icon } from 'semantic-ui-react';

import PermissionSets from './PermissionSets';

export default {
  label: 'Permission Sets',
  url: '/o/permission-sets',
  icon: <Icon name="key" />,
  content: PermissionSets,
};
